"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var format_exports = {};
__export(format_exports, {
  ddmmyyyy: () => ddmmyyyy,
  defaultTimestampFormat: () => defaultTimestampFormat,
  hhmm: () => hhmm,
  isIso8601: () => isIso8601,
  iso8601Regex: () => iso8601Regex,
  iso8601TimestampFormat: () => iso8601TimestampFormat,
  unsafeTimestampFormat: () => unsafeTimestampFormat,
  yyyymmdd: () => yyyymmdd,
  yyyymmddhhmm: () => yyyymmddhhmm
});
module.exports = __toCommonJS(format_exports);
var import_util = require("@cartographerio/util");
const iso8601Regex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,9}))?Z/;
function isIso8601(value) {
  return typeof value === "string" && iso8601Regex.test(value);
}
function unsafeTimestampFormat(str) {
  return (0, import_util.unsafeTag)(str);
}
const ddmmyyyy = unsafeTimestampFormat("dd/MM/yyyy");
const yyyymmdd = unsafeTimestampFormat("yyyy-MM-dd");
const hhmm = unsafeTimestampFormat("HH:mm");
const yyyymmddhhmm = unsafeTimestampFormat(`${yyyymmdd} ${hhmm}`);
const defaultTimestampFormat = unsafeTimestampFormat(`${ddmmyyyy} ${hhmm}`);
const iso8601TimestampFormat = unsafeTimestampFormat("yyyy-MM-dd'T'kk:mm:ss.SSSX");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ddmmyyyy,
  defaultTimestampFormat,
  hhmm,
  isIso8601,
  iso8601Regex,
  iso8601TimestampFormat,
  unsafeTimestampFormat,
  yyyymmdd,
  yyyymmddhhmm
});
//# sourceMappingURL=format.js.map
